import { parseJson } from 'legacy/lut/classes/helpers/JsonHelper'

import { IP360PartnerFlags } from 'partner360/models/p360PartnerFlags/IP360PartnerFlags'
import { IPartnerWithFlagRequests } from 'partner360/models/partnerFlagRequests/IPartnerWithFlagRequests'

import { PartnerFlagRequestHistoryCard } from './PartnerFlagRequestHistoryCard'

interface Props {
  item: IPartnerWithFlagRequests
  partnerFlags: IP360PartnerFlags[]
}

export const PartnerFlagRequestDetails = ({ item, partnerFlags }: Props) => {
  if (!item.Request || !item.RequestStatus || !item.RequestCreatedBy || !item.RequestCreated) {
    return null
  }

  return (
    <PartnerFlagRequestHistoryCard
      request={parseJson(item.Request)}
      status={item.RequestStatus}
      createdBy={item.RequestCreatedBy}
      created={item.RequestCreated}
      partnerFlags={partnerFlags}
    />
  )
}
